module.exports = __webpack_public_path__ + "3faa53389da2f66408f49bdc28840425.pdf";